import React from "react";
import { CampaignTemplate } from "../../../externalComponents/CampaignTemplate";

export default function CreateCampaignFromTemplatePage() {
  return <CampaignTemplate />;
}
